<template>
  <div class="card-base" :style="marginObject">
    <div :style="styleObject">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "card-base",
  props: {
    styleObject: {
      type: Object,
      default: this.styleDefault,
    },
    marginObject: {
      type: Object,
      default: this.styleDefault,
    },
  },
  data() {
    return {
      styleDefault: {},
    };
  },
};
</script>

<style lang="scss" scoped>
.card-base {
  width: 100%;
  @include box-sizing(border-box);
  background-color: #fff;
  overflow: hidden;
  @include border-radius(0.1rem);
  @include box-shadow(0px 3px 10px rgba(0, 0, 0, 0.05));

  &:hover {
    @include box-shadow(5px 10px 10px 5px rgba(0, 0, 0, 0.05));
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Card/CardBase.vue